import React, {useState} from 'react'

let CARD_W = 115
let CARD_H = 160

let Card = ({card, width, height}) => {
  let [loaded, setLoaded] = useState(false)
  let w = width || CARD_W
  let h = height || CARD_H

  return (
    <div style={{borderRadius: 4, overflow: 'hidden', width: w, height: h, background: '#333'}}>
      {card?.url ? (
        <img
          src={card.url}
          alt={card.name || ''}
          style={{width: w, height: h, display: loaded ? 'block' : 'none', objectFit: 'cover'}}
          onLoad={() => setLoaded(true)}
          draggable={false}
        />
      ) : null}
      {(!card?.url || !loaded) && (
        <div style={{width: w, height: h, background: '#444', borderRadius: 4}} />
      )}
    </div>
  )
}

export default Card
